import React from 'react';
import { useSearchBox } from 'react-instantsearch-hooks-web';
import IconMagnifyingGlass from '../ui/icons/IconMagnifyingGlass';
import { useDesktopMediaQuery } from './hooks/useResponsive';
import IconClose from '../ui/icons/IconClose';

const SearchInput = ( props ) => {
	const { query, refine, clear } = useSearchBox( props );
	const isDesktop = useDesktopMediaQuery();

	const placeholder = isDesktop ? 'Search for neighborhood, amenities, school districts, etc.' : 'Search for neighborhood, amenities, etc.';

	return (
		<div className="tw-relative">
			<span className='tw-absolute tw-left-4 tw-top-[15px]'>
				<IconMagnifyingGlass />
			</span>
			<input
				className="tw-py-3 tw-pl-10 tw-pr-3 tw-bg-sheer tw-w-full tw-placeholder-charcoal"
				type="text"
				placeholder={placeholder}
				value={query}
				onChange={( event ) => {
					refine( event.currentTarget.value );
				}}
			/>
			{query && (
				<button
					type="button"
					aria-label='Clear search input'
					onClick={() => clear()}
					className="tw-group tw-bg-transparent tw-absolute tw-bottom-[6px] tw-right-1 tw-p-2">
					<IconClose fill="steel" />
				</button>
			)}
		</div>
	);
};

export default SearchInput;
